<template>
    <div>
        <b-card no-body class="mb-2">
            <b-card-header header-tag="header" class="p-3 d-flex justify-content-between" role="tab">

                <div class="d-flex gap-2 align-items-center flex-grow-1 text-dark" v-b-toggle="'module-' + module.id">
                    <svg class="when-closed" height="20px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
                        <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                    </svg>
                    <svg class="when-open" height="20px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                      </svg>


                    <h5 class="font-weight-bold-500 p-0 m-0 " >
                        {{ module.name }}
                    </h5>

                </div>

                <div>
                    <span class="text-muted">
                        <!-- Percent -->
                        <span v-if="module.lessons_count > 0">
                            {{ Math.round((module.views_count / module.lessons_count) * 100) }}% concluído
                        </span>
                        <span v-else>
                            ---
                        </span>
                    </span>
                </div>
            </b-card-header>
            <b-collapse :id="'module-' + module.id" accordion="ecorrecao" role="tabpanel">
                <b-card-body>
                    <div v-if="module.lessons.length === 0" class="bg-light rounded border p-3 text-left">
                        Ainda não existem aulas neste módulo :(
                    </div>

                    <div v-for="lesson in module.lessons" :key="lesson.id">
                        <lesson-item :lesson="lesson" :module="module"></lesson-item>
                    </div>
                </b-card-body>
            </b-collapse>
        </b-card>
    </div>
</template>

<script>
import LessonItem from "./LessonItem";

export default {
    props: ['module'],
    components: {
        LessonItem,
    },
    methods: {
    }
}
</script>

<style scoped>
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
</style>
